import {
  Button,
  FormControlLabel,
  Checkbox,
  makeStyles,
  CircularProgress,
  IconButton,
  Tooltip
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import FacebookIcon from '@material-ui/icons/Facebook'
import InstagramIcon from '@material-ui/icons/Instagram'
import GitHubIcon from '@material-ui/icons/GitHub'
import StackoverflowIcon from '../Images/icons8-stack-overflow-26.png'
import CheckUserProvider from '../AllHooks/CheckUserProvider'
import CustomAlert from './CustomAlert'
import { useForm } from 'react-hook-form'
import { registerUser, socialMediaLink } from './Models/AccountModel'
import { uploadCVDocument, getDownloadUrlFromFullPath, uploadImageUsingFilepath, formParams, checkValidation } from '../Backend/firebase/user'
import server from '../Backend/axios'
import { mapValues } from 'lodash'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { Helmet } from 'react-helmet';

import '../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css'
import '../../node_modules/@syncfusion/ej2-popups/styles/material.css'
import '../../node_modules/@syncfusion/ej2-react-calendars/styles/material.css'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import db, { auth } from '../Backend/firebase/firebase'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1': {
      fontSize: '14px',
    },
    '& .MuiFormControlLabel-root.makeStyles-root-16': {
      display: 'flex',
      alignItems: 'center',
    },
  },
}))

function UpdatePersonalDetail() {
  const classes = useStyles()
  const { userData } = CheckUserProvider()
  const [openNotify, setOpenNotify] = useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [checkEmail, setCheckEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { register, errors, handleSubmit, setValue } = useForm()
  const [isPersonOutsideFromNl, setIsPersonOutsideFromNl] = useState(false)
  //const [isPersonNlChecked, setIsPersonNlChecked] = useState(false);
  const [personalDetail, setPersonalDetail] = useState(null)
  const [dateDoe, setDateDoe] = useState(new Date())
  const [userDetail, setUserDetail] = useState(null);

  useEffect(async () => {
    if (userData) {
      // await bindInitialData();
      setUserDetail(userData);
      setTimeout(() => {
        mapValues(userData, (value, key) =>
          setValue(key, value),
        )
        mapValues(userData, (value, key) =>
          setValue(key, value),
        )
        setDateDoe(userData.doe)
      })
      setPersonalDetail(userData)
    }
  }, [userData]);

  const bindInitialData = async () => {
    await server
      .get(`/Account/GetUserDetailsForUpdateByUidAsync/${userData.uid}`)
      .then((resp) => {
        if (resp.status === 200 && resp.data.message === 'success') {
          setUserDetail(resp.data.data.user);
          setTimeout(() => {
            mapValues(resp.data.data.user, (value, key) =>
              setValue(key, value),
            )
            mapValues(resp.data.data.socialMediaData, (value, key) =>
              setValue(key, value),
            )
            setDateDoe(resp.data.data.user.doe)
            setIsPersonOutsideFromNl(
              resp.data.data.user.isPersonOutsideFromNL,
            )
          })
          setPersonalDetail(resp.data.data)
        }
      })
      .catch((err) => console.log(err.message))
  };

  const downloadCV = async (path) => {
    var url = await getDownloadUrlFromFullPath(path);
    const newWindow = window.open();
    newWindow.location.href = url;
  };

  const handleisPersonOutsideFromNLChange = (e) => {
    setIsPersonOutsideFromNl(e.target.checked)
    if (e.target.checked) {
      setValue('zipcode', '');
      setValue('houseNr', '');
    }
  }

  const handleDoeChange = (e) => {
    setDateDoe(e.target.value);
  }

  const onSubmit = async (data) => {
    setIsLoading(true)
    try {
      registerUser.uid = userData.uid
      registerUser.nameTitle = data.nameTitle
      registerUser.name = data.name
      if (dateDoe) {
        registerUser.doe = dateDoe
      } else {
        registerUser.doe = null
      }
      registerUser.cvDocument = data.cvDocument
      registerUser.profilePhoto = data.profilePhoto
      registerUser.phoneNumber = data.phoneNumber
      registerUser.houseNr = data.houseNr
      registerUser.zipcode = data.zipcode

      socialMediaLink.uid = userData.uid
      socialMediaLink.facebookLink = data.facebookLink
      socialMediaLink.githubLink = data.githubLink
      socialMediaLink.instagramLink = data.instagramLink
      socialMediaLink.linkedInLink = data.linkedInLink
      socialMediaLink.stackOverFlowLink = data.stackOverFlowLink
      socialMediaLink.twitterLink = data.twitterLink

      // File Upload Setting
      if (data.cvDocument.length > 0) {
        var cvPath = `Resumes/${userData.uid
          }/${userData.name}_CV.${data.cvDocument[0].name.split('.').pop()}`
        var cvRef = await uploadCVDocument(cvPath, data.cvDocument[0])
        registerUser.cvDocumentPath = cvPath
      }

      if (data.profilePhoto.length > 0) {
        var photoPathData = `users/${userData.uid
          }/${userData.name}_Photo.${data.profilePhoto[0].name.split('.').pop()}`
        var photoRef = await uploadImageUsingFilepath(photoPathData, data.profilePhoto[0]);
        registerUser.profilePhotoPath = photoPathData
      }

      try {
        var user = auth.currentUser;
        if (user) {
          try {
            const docRef = db.doc(`/Users/${user.uid}`);
            await docRef.update({
              nameTitle: formParams(data?.nameTitle),
              name: formParams(data?.name),
              doe: checkValidation(data?.doe) ? data.doe : new Date(),
              cvDocument: formParams(registerUser?.cvDocumentPath),
              phoneNumber: formParams(data?.phoneNumber),
              profilePhoto: formParams(registerUser?.profilePhotoPath),
              zipcode: formParams(data?.zipcode),
              facebookLink: formParams(data?.facebookLink),
              githubLink: formParams(data?.githubLink),
              instagramLink: formParams(data?.instagramLink),
              linkedInLink: formParams(data?.linkedInLink),
              stackOverFlowLink: formParams(data?.stackOverFlowLink),
              twitterLink: formParams(data?.twitterLink)
            });
            
            setNotificationMessage('User skills detail has updated successfully.');
            setOpenNotify(true);
            setAlertType('success');
            setIsLoading(false);
            window.location.reload(true);
          } catch(error) {
            console.log("Error Occur in Update Profile : ", error)
            setNotificationMessage('Updation Failed!');
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
          }
        }
      } catch (err) {
        if (err.code === 'auth/requires-recent-login') {
            setNotificationMessage('To change the email, please logout your account and login again!');
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
        } else {
            //console.log(err);
            setNotificationMessage('Something goes wrong!');
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
        }
      }

      // await server
      //   .put('/Account/UpdateUserPersonalDetailsAsync', {
      //     user: registerUser,
      //     socialMediaLink: socialMediaLink,
      //   })
      //   .then((resp) => {
      //     if (resp.status === 200 && resp.data.message === 'success') {
      //       setNotificationMessage(
      //         'User personal details has updated successfully.',
      //       )
      //       setOpenNotify(true)
      //       setAlertType('success')
      //       setIsLoading(false)
      //       //window.location.reload(true);
      //     } else {
      //       if (resp.data.data) {
      //         setNotificationMessage(resp.data.data)
      //         setOpenNotify(true)
      //         setAlertType('error')
      //         setIsLoading(false)
      //       } else {
      //         setNotificationMessage('Updation Failed!')
      //         setOpenNotify(true)
      //         setAlertType('error')
      //         setIsLoading(false)
      //       }
      //     }
      //   })
      //   .catch((err) => {
      //     setNotificationMessage(err.message)
      //     setOpenNotify(true)
      //     setAlertType('error')
      //     setIsLoading(false)
      //   })
    } catch (error) {
      setNotificationMessage(error.message)
      setOpenNotify(true)
      setAlertType('error')
      setIsLoading(false)
    }
  }

  return (
    <>
      {personalDetail ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row pt-1 pb-3 personalDetailsForm">
            <Helmet>
              <meta name="description" content="Update your personal details..." />
              <title>Update Personal Details | Kaipsool Pharmatech</title>
            </Helmet>
            <div className="col-md-8">
              <div className="form-group">
                <div className="row">
                  <div className="col-md-3 col-sm-4 col-5 mb-2">
                    <div className="form-group" style={{ marginTop: '2px' }}>
                      <label className="login__textboxLabel">Your Name</label>
                      <select
                        className="form-select registerEmp__textbox"
                        aria-label="Default select example"
                        name="nameTitle"
                        ref={register}
                        defaultValue="Select Option"
                      >
                        <option value="Select Option">Select Option</option>
                        <option value="Mr.">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-9 col-sm-8 col-7">
                    <div className="form-group">
                      <label className="login__textboxLabel">
                        Your Name{' '}
                        <span
                          className="text-danger"
                          style={{
                            fontSize: '18px',
                            fontWeight: '900',
                            marginLeft: '3px',
                          }}
                        >
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                          { 'is-invalid': errors.name },
                        )}
                        name="name"
                        placeholder="Name"
                        autoComplete="off"
                        ref={register({ required: 'Please enter your name!' })}
                      />
                      <small className="form-text text-danger">
                        {errors.name && errors.name.message}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-2">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Email Address{' '}
                  <span
                    className="text-danger"
                    style={{
                      fontSize: '18px',
                      fontWeight: '900',
                      marginLeft: '3px',
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  type="email"
                  className={classNames('form-control registerEmp__textbox', {
                    'is-invalid': errors.email,
                  })}
                  name="email"
                  placeholder="Email Address"
                  autoComplete="none"
                  onChange={(e) => setCheckEmail(e.target.value)}
                  ref={register({
                    required: 'Please enter your email address!',
                  })}
                  disabled
                />
                <small className="form-text text-danger">
                  {errors.email && errors.email.message}
                </small>
              </div>
            </div>
            <div className="col-md-4 mb-2">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Date of birth (non mandatory)
                </label>
                {/* <input type="date" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.doe })}
                                    name="doe" placeholder="Date of birth" autoComplete="none"
                                    ref={register} defaultValue={dateDoe} /> */}
                <DatePickerComponent
                  id="doe"
                  value={dateDoe}
                  cssclassName="e-outline"
                  onChange={(e) => handleDoeChange(e)}
                  ref={register}
                  format="dd/mm/yyyy"
                />
              </div>
            </div>
            <div className="col-md-4 mb-2">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Phone Number (non mandatory)
                </label>
                <input
                  type="text"
                  className={classNames('form-control registerEmp__textbox', {
                    'is-invalid': errors.phoneNumber,
                  })}
                  name="phoneNumber"
                  placeholder="Phone Number"
                  autoComplete="none"
                  ref={register}
                />
              </div>
            </div>
            <div className="col-md-3 mb-2">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Your Photo (non mandatory)
                </label>
                <input
                  type="file"
                  className={classNames('form-control registerEmp__textbox', {
                    'is-invalid': errors.profilePhoto,
                  })}
                  name="profilePhoto"
                  placeholder="Profile Photo"
                  accept=".png,.jpg,.jpeg"
                  ref={register}
                />
              </div>
            </div>
            <div className="col-md-1 mb-2">
              <div className="form-group mt-md-4">
                {userDetail ? userDetail.profilePhotoPath &&
                  <Tooltip title="View current photo" placement="top">
                    <IconButton color="secondary"
                      onClick={() => downloadCV(userDetail.profilePhotoPath)}>
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip> : ''}
              </div>
            </div>
            <div className="col-md-12 mb-2">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="login__textboxLabel">
                      Zipcode{' '}
                    </label>
                    <input
                      type="text"
                      className={classNames(
                        'form-control registerEmp__textbox',
                        { 'is-invalid': errors.zipcode },
                      )}
                      name="zipcode"
                      placeholder="Zipcode"
                      autoComplete="none"
                      ref={register({
                        required: !isPersonOutsideFromNl
                          ? 'Please enter zipcode!'
                          : false,
                      })}
                    />
                    <small className="form-text text-danger">
                      {errors.zipcode && errors.zipcode.message}
                    </small>
                    {/* {!isPersonOutsideFromNl ? <small className="form-text text-danger">Please enter the zipcode!</small> : ''} */}
                  </div>
                </div>
                <div className="col-md-4 mb-2">
                  <div className="form-group">
                    <label className="login__textboxLabel">
                      Your CV (non mandatory)
                    </label>
                    <input
                      type="file"
                      className={classNames('form-control registerEmp__textbox', {
                        'is-invalid': errors.cvDocument,
                      })}
                      name="cvDocument"
                      placeholder="Your CV"
                      accept=".docs,.doc,.pdf"
                      ref={register}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-1 mb-2">
              <div className="form-group mt-md-4">
                {userDetail ? userDetail.cvDocumentPath &&
                  <Tooltip title="View CV" placement="top">
                    <IconButton color="secondary"
                      onClick={() => downloadCV(userDetail.cvDocumentPath)}>
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip> : ''}
              </div>
            </div>
          </div>
          <div className="row personalDetailsSocialData">
            <div className="col-md-12 mb-2">
              <h4 className="personalDetailsSocialData__title">
                Your social media
              </h4>
            </div>
            <div className="col-md-6 mb-1">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Twitter account (non mandatory)
                </label>
                <div className="input-group mb-3">
                  <span
                    className="input-group-text twitterIconStyle"
                    id="basic-addon1"
                  >
                    @
                  </span>
                  <input
                    type="text"
                    aria-label="twitterLink"
                    aria-describedby="basic-addon1"
                    className={classNames('form-control registerEmp__textbox', {
                      'is-invalid': errors.twitterLink,
                    })}
                    name="twitterLink"
                    autoComplete="none"
                    ref={register}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-1">
              <div className="form-group">
                <label className="login__textboxLabel">
                  LinkedIn account (non mandatory)
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <LinkedInIcon />
                  </span>
                  <input
                    type="text"
                    aria-label="linkedInLink"
                    aria-describedby="basic-addon1"
                    className={classNames('form-control registerEmp__textbox', {
                      'is-invalid': errors.linkedInLink,
                    })}
                    name="linkedInLink"
                    autoComplete="none"
                    ref={register}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-1">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Facebook account (non mandatory)
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <FacebookIcon />
                  </span>
                  <input
                    type="text"
                    aria-label="facebookLink"
                    aria-describedby="basic-addon1"
                    className={classNames('form-control registerEmp__textbox', {
                      'is-invalid': errors.facebookLink,
                    })}
                    name="facebookLink"
                    autoComplete="none"
                    ref={register}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-1">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Instagram account (non mandatory)
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <InstagramIcon />
                  </span>
                  <input
                    type="text"
                    aria-label="instagramLink"
                    aria-describedby="basic-addon1"
                    className={classNames('form-control registerEmp__textbox', {
                      'is-invalid': errors.instagramLink,
                    })}
                    name="instagramLink"
                    autoComplete="none"
                    ref={register}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-1">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Stack Overflow profile (non mandatory)
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <img
                      src={StackoverflowIcon}
                      alt="Stack OverflowIcon"
                      className="stackoverflowStyle"
                    />
                  </span>
                  <input
                    type="text"
                    aria-label="stackOverFlowLink"
                    aria-describedby="basic-addon1"
                    className={classNames('form-control registerEmp__textbox', {
                      'is-invalid': errors.stackOverFlowLink,
                    })}
                    name="stackOverFlowLink"
                    autoComplete="none"
                    ref={register}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-1">
              <div className="form-group">
                <label className="login__textboxLabel">
                  Github profile (non mandatory)
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-addon1">
                    <GitHubIcon />
                  </span>
                  <input
                    type="text"
                    aria-label="githubLink"
                    aria-describedby="basic-addon1"
                    className={classNames('form-control registerEmp__textbox', {
                      'is-invalid': errors.githubLink,
                    })}
                    name="githubLink"
                    autoComplete="none"
                    ref={register}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row pb-3">
            <div className="col-md-12 text-center mt-2">
              <Button
                type="submit"
                className="multiStepRegister__btnLogin"
                variant="contained"
              >
                {isLoading ? <CircularProgress size={18} /> : 'Submit'}
              </Button>
            </div>
          </div>
        </form>
      ) : (
        <div className="row">
          <div className="col-md-12 text-center p-4">
            <CircularProgress />
          </div>
        </div>
      )}
      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default UpdatePersonalDetail
